module.exports = __webpack_public_path__ + "img/message-processing-outline.6644983a.svg";